function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import './custom-dictionary-value-list-header.scss';
export class CustomDictionaryValueHeader {
    init(agParams) {
        this.agParams = agParams;
        this.eGui = document.createElement('div');
        this.eGui.innerHTML = `
            <div class="customHeaderLabel">${this.agParams.displayName}</div>
            <div class="customHeaderMenuButton">
                <i class="fas ${this.agParams.menuIcon}"></i>
            </div>
        `;
    }
    getGui() {
        return this.eGui;
    }
    constructor(){
        _define_property(this, "agParams", void 0);
        _define_property(this, "eGui", void 0);
    }
}
